import type { PixelSettings } from '../config/types/pixel-settings';
import { Pixel } from './Pixel';

/**
 * Factory pública: cria uma instância independente, inicializa e só então devolve.
 * Não é singleton — cada chamada produz um Pixel novo.
 * O merge de `PixelSettings` acontece no construtor de `Pixel`.
 */
export async function createPixel(settings: PixelSettings): Promise<Pixel> {
  const pixel = new Pixel(settings);

  try {
    await pixel.init();
    return pixel;
  } catch (error) {
    try {
      await pixel.destroy();
    } catch {
      // A falha de cleanup não pode esconder o erro original de init.
    }
    throw error;
  }
}
